import { action, observable } from 'mobx';
import { setter } from 'mobx-decorators';
import get from 'lodash/get';
import queryString from 'query-string';
import * as constants from 'Constants';


export class FormOption {
  @setter @observable value;
  @setter @observable name;
  @setter @observable desc;

  constructor() {
    this.reset();
  }

  @action reset() {
    this.value = '';
    this.name = '';
    this.desc = '';
  }

  @action deserialize(data) {
    this.value = data.value;
    this.name = data.name;
    this.desc = data.desc;
  }
}


// Used for resetting `Store`
export function setFieldValues(self, defaults) {
  for (var fieldName in defaults) {
    let defaultValue = defaults[fieldName];
    self[fieldName] = defaultValue;
  }
};


// Ensure no duplicate fields for mappers
export function concatDeserializeMappers(firstMappers, secondMappers) {
    let fields = secondMappers.map((mapper) => mapper.field);
    firstMappers = firstMappers.filter((mapper) => !fields.includes(mapper.field));
    return [].concat(firstMappers, secondMappers);
};



// Mapper must have "cls" field returning object's class
export function deserializeObject(mapper, value) {
  const instance = new mapper.cls();
  if (value) instance.deserialize(value);
  return instance;
};


// Mapper must have "cls" field returning object's class. Value must be an array.
export function deserializeArrayObjects(mapper, value) {
    if (!(value instanceof Array)) {
      throw new Error(`Expecting array object for accessor (${accessor}) with ${data}`);
    };

    const instanceList = [];
    value.forEach(function(rowData){
      const instance = new mapper.cls();
      instance.deserialize(rowData);
      instanceList.push(instance);
    });

    return instanceList;
};


export function deserializeWithMappers(self, mappers, data) {
  for (var mapper of mappers) {

    // By default, use `field` as accessor
    let accessor = 'accessor' in mapper ? mapper.accessor : mapper.field;

    // If can't find value from data with accessor, skip.
    let value = get(data, accessor, null);
    if (value === null) continue;

    // What it actually does:
    // this.id = data.id;
    if (!('type' in mapper)) {
      self[mapper.field] = value;
    }

    // What it actually does:
    // let account = new AccountStore();
    // if (data.account) account.deserialize(data.account);
    if (mapper.type === constants.DESERIALIZE_TYPE_OBJECT) {
      self[mapper.field] = deserializeObject(mapper, value);
    };

    // What it actually does:
    // let accounts = [];
    // data.accounts.forEach(function(rowData){
    //   let account = new AccountStore();
    //   account.deserialize(rowData);
    //   accounts.push(account);
    // });
    if (mapper.type === constants.DESERIALIZE_TYPE_ARRAY_OBJECTS) {
      self[mapper.field] = deserializeArrayObjects(mapper, value);
    };

    // Custom extract function to retrieve deserialized value
    if (mapper.type === constants.DESERIALIZE_TYPE_CUSTOM) {
      self[mapper.field] = mapper.extract(mapper, data, accessor, value);
    };
  }
};


